export type Timeframe = "10m" | "1h" | "1d"
export const TimeUnit = {
  Day: "Day",
  Hour: "Hour",
  Min: "Min",
} as const

export type TimeUnit = (typeof TimeUnit)[keyof typeof TimeUnit]

export type Periodicity = {
  period: number
  interval: number
  timeUnit: TimeUnit
  timeframe: Timeframe
}

type TimeFrameConfig = Record<Timeframe, Periodicity>

export const timeframeConfig: TimeFrameConfig = {
  "10m": {
    period: 1,
    interval: 10,
    timeUnit: TimeUnit.Min,
    timeframe: "10m",
  },
  "1h": {
    period: 1,
    interval: 1,
    timeUnit: TimeUnit.Hour,
    timeframe: "1h",
  },
  "1d": {
    period: 1,
    interval: 1,
    timeUnit: TimeUnit.Day,
    timeframe: "1d",
  },
}
